import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransitionStage] = useState('fadeIn');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (location.pathname !== displayLocation.pathname) {
      setIsLoading(true);
      setTransitionStage('fadeOut');
    }
  }, [location, displayLocation]);

  useEffect(() => {
    // Scroll to top on route change
    if (transitionStage === 'fadeIn') {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [transitionStage]);

  return (
    <>
      {isLoading && <LoadingSpinner />}
      <div
        className={`page-transition ${transitionStage}`}
        onAnimationEnd={() => {
          if (transitionStage === 'fadeOut') {
            // Small delay to show loading spinner
            setTimeout(() => {
              setTransitionStage('fadeIn');
              setDisplayLocation(location);
              setIsLoading(false);
            }, 200);
          }
        }}
      >
        {displayLocation.pathname === location.pathname ? children : null}
      </div>
    </>
  );
};

export default PageTransition;
